module.exports = __webpack_public_path__ + "img/camera-off.0a1ebdac.svg";